import { QuickSocialExportSettings } from '@app/modules/social-export/components/settings/QuickSocialExportSettings';
import { SocialPlatform } from '@app/modules/social-export/domain/platforms';
import { Stack } from '@mui/material';
import { QuickPlatformConnectionField } from './QuickPlatformConnectionField';

type Props = {
  stationId: string;
  platform: SocialPlatform;
};

/**
 * Connection selector and platform-specific settings shown when a quick upload toggle is on.
 */
export function QuickPlatformUploadDetails({ stationId, platform }: Props) {
  const fieldPrefix = `platformUpload.${platform.id}`;

  return (
    <Stack spacing={1} sx={{ px: 1.5, pb: 1, '&:empty': { display: 'none' } }}>
      <QuickPlatformConnectionField
        stationId={stationId}
        platform={platform}
        fieldPrefix={fieldPrefix}
      />
      <QuickSocialExportSettings platform={platform} fieldPrefix={fieldPrefix} />
    </Stack>
  );
}
